import script from "./ResultCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResultCard.vue?vue&type=script&lang=ts&setup=true"

import "./ResultCard.vue?vue&type=style&index=0&id=4e4946b3&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e4946b3"]])

export default __exports__